import axios from "axios";

const TOKEN_API_KEY = process.env.REACT_APP_TOKEN_API_KEY;
const TOKEN_API_SECRET = process.env.REACT_APP_TOKEN_API_SECRET;
const GITHUB_CLIENT_ID = process.env.REACT_APP_GITHUB_CLIENT_ID;
const GITHUB_CLIENT_SECRET = process.env.REACT_APP_GITHUB_CLIENT_SECRET;
const API_URL = process.env.REACT_APP_API_URL;
const PAYMENT_API_URL = process.env.REACT_APP_PAYMENT_API_URL;

// eslint-disable-next-line
export default {
  GetToken() {
    return axios({
      method: "post",
      url: `${API_URL}get-token`,
      data: {
        key: TOKEN_API_KEY,
        secret: TOKEN_API_SECRET,
      },
    });
  },
  UserRegister(token, name, lastname, email, password) {
    return axios({
      method: "post",
      url: `${API_URL}flow/user-registration`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        name: name,
        lastname: lastname,
        email: email,
        password: password,
      },
    });
  },
  UserLogin(token, credential, password) {
    return axios({
      method: "post",
      url: `${API_URL}flow/user-login`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        credential: credential,
        password: password,
      },
    });
  },

  SendOTPForResetPassword(token, otp, email) {
    return axios({
      method: "post",
      url: `${API_URL}flow/send-otp-for-change-users-password`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        otp,
        email,
      },
    });
  },

  ResetPassword(token, otp, email, password) {
    return axios({
      method: "post",
      url: `${API_URL}flow/change-user-password-with-otp-and-email`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        otp,
        email,
        password,
      },
    });
  },

  GetGoogleUser(token) {
    return axios({
      method: "post",
      url: `https://www.googleapis.com/oauth2/v3/userinfo`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },

  GetGithubToken(code) {
    return axios({
      method: "post",
      url: `https://github.com/login/oauth/access_token`,
      headers: {
        Accept: "application/json",
      },
      data: {
        client_id: GITHUB_CLIENT_ID,
        client_secret: GITHUB_CLIENT_SECRET,
        code,
      },
    });
  },

  GetGithubUser(token) {
    return axios({
      method: "get",
      url: `https://api.github.com/user`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },

  GetGithubEmails(token) {
    return axios({
      method: "get",
      url: `https://api.github.com/user/emails`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },

  UserLoginWithThirdParty(token, type, credentials, thirdPartyToken) {
    return axios({
      method: "post",
      url: `${API_URL}flow/login-with-third-party`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        type,
        credentials,
        thirdPartyToken,
      },
    });
  },

  UpdateUser(token, userId, name, lastname, email, phone, countryCode) {
    const updateData = {};

    if (name !== undefined) updateData.name = name;
    if (lastname !== undefined) updateData.lastname = lastname;
    if (email !== undefined) updateData.email = email;
    if (phone !== undefined) updateData.phone = phone;
    if (countryCode !== undefined) updateData.countryCode = countryCode;

    return axios({
      method: "post",
      url: `${API_URL}flow/update-user`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        id: userId,
        updateData: updateData,
      },
    });
  },

  UpdateUserSubscriptionType(token, userId, subscriptionPackageType) {
    return axios({
      method: "post",
      url: `${API_URL}flow/update-user`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        id: userId,
        updateData: {
          subscriptionPackageType
        },
      },
    });
  },

  UpdateUserSettings(token, settings) {
    return axios({
      method: "post",
      url: `${API_URL}flow/update-user-settings`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        settings,
      },
    });
  },
  UpdateUserTheme(token, theme) {
    return axios({
      method: "post",
      url: `${API_URL}flow/update-user-settings`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        webTheme: theme,
      },
    });
  },
  GetUserSettings(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/settings-by-user-id`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },

  InviteCollabrators(token, email, type) {
    return axios({
      method: "post",
      url: `${API_URL}flow/collaborator-invitation`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        email,
        type,
      },
    });
  },

  ChangeTheme(token, userId, theme) {
    return axios({
      method: "post",
      url: `${API_URL}flow/update-user`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        id: userId,
        updateData: {
          theme: theme,
        },
      },
    });
  },

  UpdateUserPassword(token, userId, password) {
    return axios({
      method: "post",
      url: `${API_URL}flow/update-user`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        id: userId,
        updateData: {
          password: password,
        },
      },
    });
  },

  UpdateUserData(token, userId, updateData) {
    return axios({
      method: "post",
      url: `${API_URL}flow/update-user`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        id: userId,
        updateData: updateData,
      },
    });
  },
  CreateCollection(token, title, userID, projectId) {
    return axios({
      method: "post",
      url: `${API_URL}flow/collection-create`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        title: title,
        description: "Description",
        settings: "Settings",
        userId: userID,
        projectId: projectId,
      },
    });
  },
  UpdateCollection(token, collectionId, title) {
    return axios({
      method: "post",
      url: `${API_URL}flow/collection-update`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        id: collectionId,
        updateData: {
          title: title,
        },
      },
    });
  },
  DeleteCollection(token, collectionId) {
    return axios({
      method: "post",
      url: `${API_URL}flow/collection-delete`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        id: collectionId,
      },
    });
  },

  CreateProject(token, title, description) {
    return axios({
      method: "post",
      url: `${API_URL}flow/project-create`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        title,
        description,
      },
    });
  },

  CreateSubProject(token, projectID, title, description) {
    return axios({
      method: "post",
      url: `${API_URL}flow/create-sub-project`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        projectID,
        title,
        description,
      },
    });
  },

  UpdateSubProject(token, subProjectID, updateData) {
    return axios({
      method: "post",
      url: `${API_URL}flow/update-sub-project`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        subProjectID,
        updateData,
      },
    });
  },

  DeleteSubProject(token, subProjectID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/delete-sub-project`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        subProjectID,
      },
    });
  },

  DeleteProject(token, projectId) {
    return axios({
      method: "post",
      url: `${API_URL}flow/project-delete`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        id: projectId,
      },
    });
  },

  UpdateProject(token, projectId, title) {
    return axios({
      method: "post",
      url: `${API_URL}flow/project-update`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        id: projectId,
        updateData: {
          title: title,
        },
      },
    });
  },

  GetMyCollections(token, projectID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-my-auth-collections`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        projectID: projectID,
      },
    });
  },

  CreateAPI(
    token,
    collectionId,
    title,
    method,
    url,
    authorization,
    headers,
    body,
    members
  ) {
    return axios({
      method: "post",
      url: `${API_URL}flow/api-create`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        collectionId: collectionId,
        title: title,
        method: method,
        url: url,
        auth: authorization,
        headers: headers,
        body: body,
        members: members,
      },
    });
  },

  UpdateAPI(
    token,
    collectionId,
    apiId,
    title,
    method,
    url,
    authorization,
    headers,
    body
  ) {
    const updateData = {
      method: method,
      url: url,
      auth: authorization,
      headers: headers,
      body: body,
    };

    if (title !== null) {
      updateData.title = title;
    }

    return axios({
      method: "post",
      url: `${API_URL}flow/api-update`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        collectionId: collectionId,
        apiId: apiId,
        updateData: updateData,
      },
    });
  },

  UpdateAPITitle(token, collectionId, apiId, title) {
    return axios({
      method: "post",
      url: `${API_URL}flow/api-update`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        collectionId: collectionId,
        apiId: apiId,
        updateData: {
          title: title,
        },
      },
    });
  },

  ChangeAPIGroup(token, collectionId, apiId, groupId) {
    return axios({
      method: "post",
      url: `${API_URL}flow/api-update`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        collectionId: collectionId,
        apiId: apiId,
        updateData: {
          groupId: groupId,
        },
      },
    });
  },

  CreateAPIGroup(token, title, projectId, collectionId) {
    return axios({
      method: "post",
      url: `${API_URL}flow/api-group-create`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        title: title,
        projectId: projectId,
        collectionId: collectionId,
      },
    });
  },

  UpdateAPIGroup(token, id, title) {
    return axios({
      method: "post",
      url: `${API_URL}flow/api-group-update`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        id: id,
        updateData: {
          title: title,
        },
      },
    });
  },

  DeleteAPIGroup(token, id) {
    return axios({
      method: "post",
      url: `${API_URL}flow/api-group-delete`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        id: id,
      },
    });
  },

  DeleteAPI(token, apiId) {
    return axios({
      method: "post",
      url: `${API_URL}flow/api-delete`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        apiId: apiId,
      },
    });
  },

  CreateDocumentation(token, collectionId, apiId, title, parameters) {
    return axios({
      method: "post",
      url: `${API_URL}flow/document-create`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        collectionId: collectionId,
        apiId: apiId,
        title: title,
        parameters: parameters,
      },
    });
  },
  UpdateDocumentation(token, apiId, id, updateData) {
    return axios({
      method: "post",
      url: `${API_URL}flow/document-update`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        apiId: apiId,
        id: id,
        updateData: updateData,
      },
    });
  },
  GetDocumentationByApiID(token, apiId) {
    return axios({
      method: "post",
      url: `${API_URL}flow/documents-by-api-id`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        apiId: apiId,
      },
    });
  },

  GetMyPanels(token, projectID, startDate, endDate) {
    const data = { projectID };
    if (startDate && endDate) {
      data.startDate = startDate;
      data.endDate = endDate;
    }
    return axios({
      method: "post",
      url: `${API_URL}flow/get-my-auth-panels`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: data,
    });
  },
  CreatePanel(token, title, projectId) {
    return axios({
      method: "post",
      url: `${API_URL}flow/task-panel-create`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        title: title,
        projectId: projectId,
      },
    });
  },
  UpdatePanel(token, panelId, title) {
    return axios({
      method: "post",
      url: `${API_URL}flow/task-panel-update`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        panelId: panelId,
        updateData: {
          title: title,
        },
      },
    });
  },
  DeletePanel(token, panelId) {
    return axios({
      method: "post",
      url: `${API_URL}flow/task-panel-delete`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        panelId: panelId,
      },
    });
  },
  CreateBoard(token, panelId, title, members, projectId) {
    return axios({
      method: "post",
      url: `${API_URL}flow/board-create`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        title: title,
        panelId: panelId,
        members: members,
        projectId: projectId,
      },
    });
  },
  UpdateBoard(token, boardId, updateData) {
    return axios({
      method: "post",
      url: `${API_URL}flow/board-update`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        boardId: boardId,
        updateData,
      },
    });
  },
  DeleteBoard(token, boardId) {
    return axios({
      method: "post",
      url: `${API_URL}flow/board-delete`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        boardId: boardId,
      },
    });
  },
  CreateTask(token, data) {
    return axios({
      method: "post",
      url: `${API_URL}flow/task-create`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data,
    });
  },

  LeaveTask(token, taskId, memberIds) {
    return axios({
      method: "post",
      url: `${API_URL}flow/leave-member`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        id: taskId,
        memberIds,
        table: "task-management-jobs",
      },
    });
  },

  CreateTodo(token, taskId, todoList) {
    return axios({
      method: "post",
      url: `${API_URL}flow/task-update`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        taskId: taskId,
        updateData: {
          taskTodo: todoList,
        },
      },
    });
  },
  UpdateTodo(token, taskId, todoList) {
    return axios({
      method: "post",
      url: `${API_URL}flow/task-update`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        taskId: taskId,
        updateData: {
          taskTodo: todoList,
        },
      },
    });
  },
  ChangeTaskStatus(token, taskId, status) {
    return axios({
      method: "post",
      url: `${API_URL}flow/task-change-status`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        taskId: taskId,
        status: status,
      },
    });
  },
  UpdateTaskDates(token, taskId, startDate, endDate) {
    const updateData = {};

    if (startDate) updateData.taskStart = startDate;
    if (endDate) updateData.taskEnd = endDate;

    return axios({
      method: "post",
      url: `${API_URL}flow/task-update`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        taskId: taskId,
        updateData: updateData,
      },
    });
  },
  UpdateTaskDescription(token, taskId, description) {
    return axios({
      method: "post",
      url: `${API_URL}flow/task-update`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        taskId: taskId,
        updateData: {
          description: description,
        },
      },
    });
  },

  UpdateTask(token, taskId, updateData) {
    return axios({
      method: "post",
      url: `${API_URL}flow/task-update`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        taskId: taskId,
        updateData,
      },
    });
  },
  DeleteTask(token, taskId) {
    return axios({
      method: "post",
      url: `${API_URL}flow/task-delete`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        taskId: taskId,
      },
    });
  },

  WriteComment(token, taskId, comment, attachment, repliedCommentId) {
    return axios({
      method: "post",
      url: `${API_URL}flow/task-management-comment-write`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        taskId,
        comment,
        attachment,
        repliedCommentId,
      },
    });
  },

  DeleteComment(token, taskCommentId) {
    return axios({
      method: "post",
      url: `${API_URL}flow/task-management-comment-delete`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        taskCommentId,
      },
    });
  },

  DeleteAttachment(token, attachmentId) {
    return axios({
      method: "post",
      url: `${API_URL}flow/task-attachment-delete`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        attachmentId,
      },
    });
  },

  DeleteCommentAttachment(token, attachmentId) {
    return axios({
      method: "post",
      url: `${API_URL}flow/comment-attachment-delete`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        attachmentId,
      },
    });
  },

  AddTaskAttachment(token, taskId, attachment) {
    return axios({
      method: "post",
      url: `${API_URL}flow/task-attachment-add`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        taskId,
        attachment,
      },
    });
  },

  AddCommentAttachment(token, taskId, taskCommentId, attachment) {
    return axios({
      method: "post",
      url: `${API_URL}flow/comment-attachment-add`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        taskId,
        taskCommentId,
        attachment,
      },
    });
  },

  UpdateComment(token, taskCommentId, updateData) {
    return axios({
      method: "post",
      url: `${API_URL}flow/task-management-comment-update`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        taskCommentId,
        updateData,
      },
    });
  },

  KronosCreateAndStart(token, projectId, title, taskId, subProjectId) {
    return axios({
      method: "post",
      url: `${API_URL}flow/kronos-create-and-start`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        projectId,
        title,
        // members,
        taskId: taskId ? taskId : "",
        subProjectId: subProjectId ? subProjectId : "",
      },
    });
  },

  KronosCreate(token, title, label, ownerId, userId) {
    return axios({
      method: "post",
      url: `${API_URL}flow/kronos-create`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        title,
        label,
        ownerId,
        userId,
      },
    });
  },

  KronosCreateManual(
    token,
    title,
    projectId,
    startDate,
    endDate,
    groupId,
    subProjectId
  ) {
    return axios({
      method: "post",
      url: `${API_URL}flow/kronos-manuel-create`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        title,
        projectId,
        kronosStartDate: startDate,
        kronosEndDate: endDate,
        groupId: groupId,
        subProjectId: subProjectId,
      },
    });
  },

  KronosDelete(token, kronosIds) {
    return axios({
      method: "post",
      url: `${API_URL}flow/kronos-delete`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        kronosIds,
      },
    });
  },

  KronosLogsDelete(token, logIds) {
    return axios({
      method: "post",
      url: `${API_URL}flow/kronos-log-delete`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        logIds,
      },
    });
  },

  KronosDiscard(token, kronosId, logId) {
    return axios({
      method: "post",
      url: `${API_URL}flow/kronos-discard`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        kronosId,
        logId,
      },
    });
  },

  KronosUpdate(token, kronosId, logId, updateData) {
    return axios({
      method: "post",
      url: `${API_URL}flow/kronos-update`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        kronosId,
        logId,
        updateData,
      },
    });
  },

  KronosChangeStatus(token, jobId, userId, status) {
    return axios({
      method: "post",
      url: `${API_URL}flow/kronos-change-status`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        userId,
        jobId,
        status,
      },
    });
  },

  GetMyKronoses(token, data) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-my-kronoses`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data,
    });
  },

  GetCollaboratorsKronoses(token, data) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-my-collaborators-kronoses`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data,
    });
  },

  KronosStart(token, userId, kronosId) {
    return axios({
      method: "post",
      url: `${API_URL}flow/kronos-start`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        userId,
        kronosId,
      },
    });
  },

  KronosStop(token, logId) {
    return axios({
      method: "post",
      url: `${API_URL}flow/kronos-stop`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        logId,
      },
    });
  },

  KronosCalculate(token, userId, jobId) {
    return axios({
      method: "post",
      url: `${API_URL}flow/kronos-calculate`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        userId,
        jobId,
      },
    });
  },

  KronosSession(token, userId, jobId) {
    return axios({
      method: "post",
      url: `${API_URL}flow/kronos-session`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        userId,
        jobId,
      },
    });
  },

  CreateKronosGroup(token, title, projectId) {
    return axios({
      method: "post",
      url: `${API_URL}flow/group-create`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        title,
        description: "",
        projectId,
        kronoses: [],
      },
    });
  },

  UpdateKronosGroup(token, groupId, kronoses) {
    return axios({
      method: "post",
      url: `${API_URL}flow/group-update`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        groupId,
        updateData: {
          kronoses: kronoses,
        },
      },
    });
  },

  GetCurrentKronos(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/kronos-current-log`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },

  SetUserSelectedProjectId(token, userId, selectedProjectId) {
    return axios({
      method: "post",
      url: `${API_URL}flow/update-user`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        id: userId,
        updateData: {
          selectedProject: selectedProjectId,
        },
      },
    });
  },

  CollabratorInvite(token, email) {
    return axios({
      method: "post",
      url: `${API_URL}flow/collaborator-invitation`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        email,
      },
    });
  },

  GetCollaborators(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-collaborators`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },

  GetReceivedInvitations(token, email) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-received-invitations`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        email,
      },
    });
  },

  GetSentInvitations(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-send-invitations`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },

  CheckUserSignedUp(token, invitationCode) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-send-invitations`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        invitationCode,
      },
    });
  },

  AcceptInvitation(token, invitationCode) {
    return axios({
      method: "post",
      url: `${API_URL}flow/collaborator-accept-invitation`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        invitationCode,
      },
    });
  },

  RejectInvitation(token, invitationCode) {
    return axios({
      method: "post",
      url: `${API_URL}flow/collaborator-reject-invitation`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        invitationCode,
      },
    });
  },

  AddMemberProject(token, id, members) {
    return axios({
      method: "post",
      url: `${API_URL}flow/add-member`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        table: "projects",
        id,
        members,
      },
    });
  },

  GetProjectMembers(token, id) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-members`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        table: "projects",
        id,
      },
    });
  },

  AddMembers(token, table, id, members) {
    return axios({
      method: "post",
      url: `${API_URL}flow/add-member`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        table,
        id,
        members,
      },
    });
  },

  GetMembers(token, table, id) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-members`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        table,
        id,
      },
    });
  },

  CreateUserAuthorization(token, userID, projectID, authorizations) {
    return axios({
      method: "post",
      url: `${API_URL}flow/create-user-authorization`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        userID: userID,
        projectID: projectID,
        authorizations: authorizations,
      },
    });
  },

  InviteToProject(token, userID, projectID, authorizations) {
    return axios({
      method: "post",
      url: `${API_URL}flow/create-user-authorization`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        userID: userID,
        projectID: projectID,
        authorizations: authorizations,
        isInvite: 1,
      },
    });
  },

  GetUserAuthorizations(token, userID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-users-authorizations-by-user-id`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        userID: userID,
      },
    });
  },

  UpdateCollaboratorAuthorizations(token, userID, projectID, authorizations) {
    return axios({
      method: "post",
      url: `${API_URL}flow/update-user-authorization`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        userID: userID,
        projectID: projectID,
        authorizations: authorizations,
      },
    });
  },

  GetCollaboratorsByProjectID(token, projectID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-users-authorizations-by-project-id`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        projectID: projectID,
      },
    });
  },

  GetCollectionAndPanelIDs(token, projectID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/collection-and-panelids-by-project-id`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        projectID: projectID,
      },
    });
  },

  RemoveUserFromProject(token, authID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/remove-user-authorization`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        authID: authID,
      },
    });
  },

  RemoveUserFromCollaborators(token, memberID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/collaborator-remove-member`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        memberID: memberID,
      },
    });
  },

  CancelCollaboratorInvitation(token, invitationCode) {
    return axios({
      method: "post",
      url: `${API_URL}flow/collaborator-cancel-invitation`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        invitationCode: invitationCode,
      },
    });
  },

  GetReceivedProjectInvites(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/project-received-invitations`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },

  AcceptProjectInvitation(token, authID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/set-auth-accept`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        authID: authID,
      },
    });
  },

  RejectProjectInvitation(token, authID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/set-auth-reject`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        authID: authID,
      },
    });
  },

  GetSentProjectInvites(token, projectID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/project-sent-invitations`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        projectID: projectID,
      },
    });
  },

  GetInvitedUserID(token, invitationCode) {
    return axios({
      method: "post",
      url: `${API_URL}flow/receiver-id-by-invitation-code`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        invitationCode: invitationCode,
      },
    });
  },

  GetInvitedEmail(token, invitationCode) {
    return axios({
      method: "post",
      url: `${API_URL}flow/receiver-email-by-invitation-code`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        invitationCode: invitationCode,
      },
    });
  },

  GetInvitedUserIDForProject(token, authID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/receiver-id-by-auth-id`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        authID: authID,
      },
    });
  },

  ResendProjectInvite(token, authID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/resend-auth-mail`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        authID: authID,
      },
    });
  },

  ResendCollaboratorInvite(token, invitationCode) {
    return axios({
      method: "post",
      url: `${API_URL}flow/collaborator-resend-mail`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        invitationCode: invitationCode,
      },
    });
  },

  SamWithPrompt(token, prompt, samSessionID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/ask-to-sam`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        prompt: prompt,
        aiType: "openai",
        sessionID: samSessionID ? samSessionID : false,
      },
    });
  },

  AddUserToTask(token, members, taskId) {
    return axios({
      method: "post",
      url: `${API_URL}flow/task-member-add`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        members: members,
        taskId: taskId,
      },
    });
  },

  RemoveUserFromTask(token, userID, taskId) {
    return axios({
      method: "post",
      url: `${API_URL}flow/task-member-delete`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        id: userID,
        taskId: taskId,
      },
    });
  },

  AddNoteFolder(token, title) {
    return axios({
      method: "post",
      url: `${API_URL}flow/folder-create`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        title: title,
        description: "",
      },
    });
  },

  GetMyNotes(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-my-notes`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },

  CreateNote(token, folderId) {
    const payload = folderId ? { folderId } : {};

    return axios({
      method: "post",
      url: `${API_URL}flow/note-write`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: payload,
    });
  },

  DeleteNoteTemporary(token, noteId) {
    return axios({
      method: "post",
      url: `${API_URL}flow/set-note-passive`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        noteId: noteId,
      },
    });
  },

  NoteUpdate(token, noteId, content) {
    return axios({
      method: "post",
      url: `${API_URL}flow/note-update`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        id: noteId,
        updateData: {
          content: content,
        },
      },
    });
  },

  NoteTitleUpdate(token, noteId, title) {
    return axios({
      method: "post",
      url: `${API_URL}flow/note-update`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        id: noteId,
        updateData: {
          title: title,
        },
      },
    });
  },

  NoteMoveFolder(token, noteId, folderId) {
    return axios({
      method: "post",
      url: `${API_URL}flow/note-update`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        id: noteId,
        updateData: {
          folderId: folderId,
        },
      },
    });
  },

  NoteStar(token, noteId) {
    return axios({
      method: "post",
      url: `${API_URL}flow/starred-note`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        noteId: noteId,
      },
    });
  },

  NoteUnstar(token, noteId) {
    return axios({
      method: "post",
      url: `${API_URL}flow/unstarred-note`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        noteId: noteId,
      },
    });
  },

  TouchToNote(token, noteId) {
    return axios({
      method: "post",
      url: `${API_URL}flow/touch-to-note`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        noteId: noteId,
      },
    });
  },

  GetRecentNotes(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-recent-notes`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },

  UpdateNoteFolder(token, id, title) {
    return axios({
      method: "post",
      url: `${API_URL}flow/folder-update`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        id: id,
        updateData: {
          title: title,
        },
      },
    });
  },

  TemporaryDeleteNoteFolder(token, id) {
    return axios({
      method: "post",
      url: `${API_URL}flow/set-folder-passive`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        folderId: id,
      },
    });
  },

  InitializePayment(
    userID,
    cardHolderName,
    cardNumber,
    expireMonth,
    expireYear,
    cvc,
    name,
    lastname,
    gsmNumber,
    email,
    address,
    city,
    country,
    postalCode,
    price,
    currency,
    identityNo
  ) {
    return axios({
      method: "post",
      url: `${PAYMENT_API_URL}initialize-payment.php`,
      data: {
        userID: userID,
        cardHolderName: cardHolderName,
        cardNumber: cardNumber,
        expireMonth: expireMonth,
        expireYear: expireYear,
        cvc: cvc,
        saveCard: true,
        name: name,
        lastname: lastname,
        gsmNumber: gsmNumber,
        email: email,
        identityNo: identityNo,
        address: address,
        city: city,
        country: country,
        postalCode: postalCode,
        price: price,
        paidPrice: price,
        locale: "EN",
        currency: currency,
        paymentGroup: "SUBSCRIPTION",
        installment: 1,
        items: [
          {
            title: "BASIC MEMBER",
            type: "VIRTUAL",
            price: price,
          },
        ],
      },
    });
  },

  ListenPayment(paymentID) {
    return axios({
      method: "post",
      url: `${PAYMENT_API_URL}listen.php`,
      data: {
        paymentID,
      },
    });
  },

  InitializeSHPayment(
    userID,
    cardHolderName,
    cardNumber,
    expireMonth,
    expireYear,
    cvc,
    name,
    lastname,
    gsmNumber,
    email,
    address,
    city,
    country,
    postalCode,
    price,
    currency,
    identityNo,
    items
  ) {
    return axios({
      method: "post",
      url: `${PAYMENT_API_URL}event-initialize-payment.php`,
      data: {
        userID: userID,
        cardHolderName: cardHolderName,
        cardNumber: cardNumber,
        expireMonth: expireMonth,
        expireYear: expireYear,
        cvc: cvc,
        saveCard: true,
        name: name,
        lastname: lastname,
        gsmNumber: gsmNumber,
        email: email,
        identityNo: identityNo,
        address: address,
        city: city,
        country: country,
        postalCode: postalCode,
        price: price,
        paidPrice: price,
        locale: "EN",
        currency: currency,
        paymentGroup: "PRODUCT",
        installment: 1,
        items,
      },
    });
  },

  ListenSHPayment(paymentID) {
    return axios({
      method: "post",
      url: `${PAYMENT_API_URL}event-listen.php`,
      data: {
        paymentID,
      },
    });
  },

  IsUserExpired(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/is-users-subscription-expired`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },

  CreatePageView(token, uri) {
    return axios({
      method: "post",
      url: `${API_URL}flow/create-page-view`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        uri,
      },
    });
  },

  SocialHiveCreateChannel(token, title, description, isPublic, logo, topBanner) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-create-channel`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        title,
        description,
        isPublic,
        isFree: true,
        links: null,
        logo,
        topBanner,
        tags: null,
      },
    });
  },

  SocialHiveUpdateChannel(
    token,
    channelID,
    title,
    description,
    isPublic,
    logo,
    topBanner
  ) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-update-channel`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        channelID,
        title,
        description,
        isPublic,
        isFree: true,
        links: null,
        logo,
        topBanner
      },
    });
  },

  SocialHiveUpdateChannelSettings(
    token,
    channelID,
    settings
  ) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-update-channel-settings`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        channelID,
        settings
      },
    });
  },

  SocialHiveGetMyChannels(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-get-my-channels`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },

  SocialHiveGetUsersEvents(token, userID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-get-users-registered-events`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        userID
      }
    });
  },

  SocialHiveCreateRoom(token, channelID, title, description, isPublic, canUsersSendMessage) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-create-room`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        channelID,
        title,
        description,
        isPublic,
        canUsersSendMessage
      },
    });
  },

  SocialHiveUpdateRoomName(token, channelID, roomID, title) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-update-room`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        channelID,
        roomID,
        title
      },
    });
  },

  SocialHiveUpdateRoomUserCanText(token, channelID, roomID, canUsersSendMessage) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-update-room`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        channelID,
        roomID,
        canUsersSendMessage
      },
    });
  },

  SocialHiveRemoveRoom(token, channelID, roomID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-remove-room`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        channelID,
        roomID
      },
    });
  },

  SocialHiveGetChannelRooms(token, channelID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-get-channel-rooms`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        channelID,
      },
    });
  },

  SocialHiveDeleteChannel(token, channelID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-remove-channel`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        channelID,
      },
    });
  },

  SocialHiveLeaveRoom(token, roomID, userID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-leave-room`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        roomID,
        userID,
      },
    });
  },

  SocialHiveJoinRoom(token, roomID, userID, channelID, isAdmin) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-join-to-room`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        userID,
        roomID,
        channelID,
        isAdmin: true,
      },
    });
  },

  SocialHiveChannelSearch(token, query) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-search-channel`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        query,
      },
    });
  },

  SocialHiveJoinToChannel(token, userID, channelID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-join-to-channel`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        userID,
        channelID,
      },
    });
  },

  SocialHiveLeaveChannel(token, userID, channelID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-leave-channel`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        userID,
        channelID,
      },
    });
  },

  SocialHiveSendMessage(token, channelID, roomID, content, messageID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-create-room-chat-message`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        channelID,
        roomID,
        content,
        messageID,
      },
    });
  },
  SocialHiveGetRoomMessages(token, channelID, roomID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-get-room-chat-messages`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        channelID,
        roomID,
        limit: 30,
      },
    });
  },

  SocialHiveGetDMMessageByID(token, messageID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-get-dm-message-by-id`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        messageID
      },
    });
  },

  SocialHiveRemoveDM(token, roomID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-remove-dm`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        roomID
      },
    });
  },

  SocialHiveAddEmotionToChannelMessage(token, messageID, roomID, channelID, content) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-add-emotion-to-channel-message`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        messageID,
        roomID,
        channelID,
        content,
      },
    });
  },

  SocialHiveRemoveEmotionFromChannelMessage(token, messageID, roomID, channelID, emotionID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-remove-emotion-from-channel-message`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        messageID,
        roomID,
        channelID,
        emotionID,
      },
    });
  },

  SocialHiveGetChannelMessageByID(token, messageID, roomID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-get-channel-message-by-id`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        messageID,
        roomID
      },
    });
  },

  SocialHiveAddEmotionToDMMessage(token, messageID, roomID, content) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-add-emotion-to-dm-message`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        messageID,
        roomID,
        content,
      },
    });
  },

  SocialHiveRemoveEmotionFromDMMessage(token, messageID, roomID, emotionID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-remove-emotion-from-dm-message`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        messageID,
        roomID,
        emotionID,
      },
    });
  },

  SocialHiveGetPreviousRoomMessages(token, channelID, roomID, startID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-get-room-chat-messages`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        channelID,
        roomID,
        limit: 30,
        startID,
      },
    });
  },

  SocialHiveDMUserSearch(token, query) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-search-user-in-my-channels`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        query,
      },
    });
  },

  SocialHiveCreateDM(token, toUserID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-create-dm`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        toUserID,
      },
    });
  },

  SocialHiveCreateDMFiles(token, file, extension, name, roomID, messageID) {

    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-upload-file-to-dm-room`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        file,
        extension,
        name,
        roomID,
        messageID
      },
    });
  },

  SocialHiveCreateRoomFiles(token, file, extension, name, roomID, messageID) {

    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-upload-file-to-channel-room`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        file,
        extension,
        name,
        roomID,
        messageID
      },
    });
  },

  SocialHiveGetDMRoomList(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-get-dm-room-list`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },

  SocialHiveDMSendMessage(token, roomID, content, messageID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-create-dm-room-chat-message`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        roomID,
        content,
        messageID,
      },
    });
  },

  SocialHiveGetDMRoomMessages(token, roomID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-get-dm`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        roomID,
        limit: 30,
      },
    });
  },

  SocialHiveChannelDailyJoinLeaveReport(token, channelID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-daily-channel-join-leave-report`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        channelID
      },
    });
  },

  SocialHiveGetPreviousDMRoomMessages(token, roomID, startID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-get-dm`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        roomID,
        limit: 30,
        startID,
      },
    });
  },

  SocialHiveCreateEvent(
    token,
    isFree,
    channelID,
    title,
    description,
    cover,
    eventStartDateTime,
    eventEndDateTime,
    isOnline,
    website,
    locationAddress,
    locationLatitude,
    locationLongitude,
    organizedBy,
    hasTickets,
    tickets,
    ticketSaleStartDateTime,
    contactEmail,
    ticketSaleNotificationEmail,
    customerNotificationMailTemplate,
    contactPhone,
    socialMediaLinks,
    usersCanSendMessage,
    isPublic,
    settings
  ) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-create-event`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        isFree,
        channelID,
        title,
        description,
        cover,
        eventStartDateTime,
        eventEndDateTime,
        isOnline,
        website,
        locationAddress,
        locationLatitude,
        locationLongitude,
        organizedBy,
        hasTickets,
        tickets,
        ticketSaleStartDateTime,
        contactEmail,
        ticketSaleNotificationEmail,
        customerNotificationMailTemplate,
        contactPhone,
        socialMediaLinks,
        usersCanSendMessage: false,
        isPublic,
        status: 1,
        settings
      },
    });
  },

  SocialHiveUpdateEvent(token, payload) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-update-event`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: payload,
    });
  },

  SocialHiveRemoveEvent(token, eventID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-remove-event`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        eventID
      },
    });
  },

  SocialHiveGetEvents(token, channelID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-get-channel-events`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        channelID,
      },
    });
  },

  SocialHiveGetAllEvents(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-get-channel-events`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      }
    });
  },

  SocialHiveGetPopularChannels(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-get-popular-channels`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      }
    });
  },

  SocialHiveGetPopularChannelEvents(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-get-popular-channel-events`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      }
    });
  },

  SocialHiveGetEventDetails(token, eventID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-get-channel-event`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        eventID,
      },
    });
  },

  SocialHiveGetEventSoldTickets(token, eventID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-get-events-sold-tickets`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        eventID,
      },
    });
  },

  SocialHiveGetEventMyTickets(token, eventID, userID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-get-events-sold-tickets`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        eventID,
        userID
      },
    });
  },

  SocialHiveGetMyAllTickets(token, userID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-get-events-sold-tickets`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        userID
      },
    });
  },

  SocialHiveAddSpeaker(
    token,
    channelID,
    eventID,
    name,
    lastname,
    speakingAboutTitle,
    speakingAbout,
    about,
    image,
    linkedin
  ) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-add-speaker-to-event`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        channelID,
        eventID,
        name,
        lastname,
        speakingAboutTitle,
        speakingAbout,
        about,
        image,
        socialMediaLinks: linkedin ? { linkedin } : undefined,
      },
    });
  },

  SocialHiveAddSponsor(
    token,
    channelID,
    eventID,
    companyTitle,
    companyAbout,
    sponsorshipType,
    sponsorshipAbout,
    image
  ) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-add-sponsor-to-event`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        channelID,
        eventID,
        companyTitle,
        companyAbout,
        sponsorshipType,
        sponsorshipAbout,
        image,
      },
    });
  },

  SocialHiveRemoveSpeaker(token, eventID, speakerID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-remove-event-speaker`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        eventID,
        speakerID,
      },
    });
  },

  SocialHiveRemoveSponsor(token, eventID, sponsorID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-remove-event-sponsor`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        eventID,
        sponsorID,
      },
    });
  },

  SocialHiveGetChannelUsers(token, channelID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-get-users`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        status: [1],
        channelID,
      },
    });
  },

  SocialHiveGetChannelUserRequests(token, channelID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-get-users`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        status: [3],
        channelID,
      },
    });
  },

  SocialHiveAssignAdminToChannel(token, channelID, userID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-assign-user-as-admin-to-channel`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        channelID,
        userID,
      },
    });
  },

  SocialHiveRevokeAdminFromChannel(token, channelID, userID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-revoke-user-as-admin-from-channel`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        channelID,
        userID,
      },
    });
  },

  SocialHiveAcceptUserToPrivateChannel(token, channelID, userID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-private-channel-user-approve`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        channelID,
        userID,
      },
    });
  },

  SocialHiveRejectUserToPrivateChannel(token, channelID, userID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-private-channel-user-reject`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        channelID,
        userID,
      },
    });
  },

  SocialHiveAddTicketToEvent(
    token,
    channelID,
    eventID,
    title,
    type,
    description,
    price,
    currency,
    trackInventory,
    inventory
  ) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-add-ticket-to-event`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        channelID,
        eventID,
        title,
        type,
        description,
        price,
        currency,
        trackInventory,
        inventory,
      },
    });
  },

  SocialHiveRemoveTicketFromEvent(token, eventID, ticketID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-remove-event-ticket`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        eventID,
        ticketID,
      },
    });
  },

  SocialHiveCreateAnnouncement(
    token,
    channelID,
    title,
    description,
    type,
    subTitle,
    image
  ) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-create-announcement`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        channelID,
        title,
        description,
        type,
        subTitle,
        image,
        status: 1,
      },
    });
  },

  SocialHiveGetAnnouncements(token, channelID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-get-announcements`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        channelID,
      },
    });
  },

  SocialHiveGetAnnouncement(token, channelID, announcementID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-get-announcement`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        channelID,
        announcementID,
      },
    });
  },

  SocialHiveCreateSoldTicket(
    token,
    channelID,
    eventID,
    ticketID,
    paymentID,
    name,
    lastname,
    email,
    phone,
    isPaid,
    billing
  ) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-create-sold-ticket`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        channelID,
        eventID,
        ticketID,
        paymentID,
        name,
        lastname,
        email,
        phone,
        isPaid,
        billing,
      },
    });
  },

  VoteModule(token, module) {
    return axios({
      method: "post",
      url: `${API_URL}flow/vote-module`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        module
      }
    });
  },

  CreateSocialHiveGalleryCollection(token, channelID, title, description, cover) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-create-channel-gallery-collection`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        channelID,
        title,
        description,
        cover
      }
    });
  },

  SocialHiveGalleryGetCollections(token, channelID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-get-channel-gallery-collections`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        channelID
      }
    });
  },

  SocialHiveGalleryGetCollectionDetail(token, channelID, collectionID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-get-channel-gallery-collections`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        channelID,
        collectionID
      }
    });
  },

  SocialHiveAddFilesToCollection(token, channelID, collectionID, title, description, files) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-add-file-to-channel-gallery`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        channelID,
        collectionID,
        title,
        description,
        files
      }
    });
  },

  SocialHiveSetDMRead(token, roomID, messageID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-read-dm-message`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        roomID,
        messageID
      }
    });
  },

  SocialHiveLikeFile(token, channelID, collectionID, fileID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-like-channel-gallery-file`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        channelID,
        collectionID,
        fileID
      }
    });
  },
  SocialHiveUnlikeFile(token, channelID, collectionID, fileID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-unlike-channel-gallery-file`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        channelID,
        collectionID,
        fileID
      }
    });
  },
  SocialHiveRemoveGalleryFolder(token, channelID, collectionID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-remove-channel-gallery-collection`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        channelID,
        collectionID
      }
    });
  },
  SocialHiveRemoveGalleryFile(token, channelID, collectionID, fileID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-remove-channel-gallery-file`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        channelID,
        collectionID,
        fileID
      }
    });
  },
  SocialHiveLabelPerson(token, channelID, userID, fileID, collectionID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-add-label-user-on-channel-gallery-file`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        channelID,
        userID,
        fileID,
        collectionID
      }
    });
  },

  SocialHiveRemoveLabelPerson(token, channelID, collectionID, fileID, labelID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-remove-channel-gallery-file-label`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        channelID,
        collectionID,
        fileID,
        labelID
      }
    });
  },

  SocialHiveCommentOnFile(token, channelID, collectionID, fileID, content) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-add-comment-on-channel-gallery-file`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        channelID,
        collectionID,
        fileID,
        content
      }
    });
  },

  GetUserSubscriptionInfos(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-user-subscription-infos`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      }
    });
  },

  RemoveChannelMessage(token, channelID, roomID, messageID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-remove-channel-room-message`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        channelID,
        roomID,
        messageID
      }
    });
  },

  SamGetUserHistory(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-my-sam-messages`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      }
    });
  },

  StarDMMessage(token, messageID, roomID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-starred-dm-message`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        messageID,
        roomID
      }
    });
  },

  UnstarDMMessage(token, messageID, roomID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-unstarred-dm-message`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        messageID,
        roomID
      }
    });
  },

  RemoveDMMessage(token, messageID, roomID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-remove-dm-message`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        messageID,
        roomID
      }
    });
  },

  StarChannelMessage(token, messageID, roomID, channelID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-starred-channel-message`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        messageID,
        roomID,
        channelID
      }
    });
  },

  UnstarChannelMessage(token, messageID, roomID, channelID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-unstarred-channel-message`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        messageID,
        roomID,
        channelID
      }
    });
  },

  GetGames(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-games`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      }
    });
  },

  GetGameSessionID(token, gameID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-games`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        gameID
      }
    });
  },

  PlayerSetOnlineInGame(token, gameID, sessionID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/set-player-online-in-game`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        gameID,
        sessionID
      }
    });
  },

  SocialHiveCommentOnEvent(token, channelID, eventID, content) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-add-comment-on-channel-event`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        channelID,
        eventID,
        content
      }
    });
  },

  SocialHiveUseTicket(token, ticketNo) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-use-event-ticket`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        ticketNo
      }
    });
  },

  GetLinkPreview(token, url) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-link-preview`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        url
      }
    });
  },

  CreateEventVisit(token, channelID, eventID, userDetails) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-create-analytics-channel-event-visit`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        channelID,
        eventID,
        userDetails
      }
    });
  },

  ExportToExcel(token, content, header, sheetTitle) {
    return axios({
      method: "post",
      url: `${API_URL}flow/create-excel`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        content,
        header,
        sheetTitle
      }
    });
  },

  LodriveCreateFolder(token, title, topDirectoryID) {
    const data = { title };
    if (topDirectoryID) data.topDirectoryID = topDirectoryID;
    return axios({
      method: "post",
      url: `${API_URL}flow/lodrive-create-directory`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data,
    });
  },

  LodriveUploadFile(token, directoryID, files) {
    const payload = directoryID == null ? { files, directoryID: "" } : { directoryID, files };

    return axios({
      method: "post",
      url: `${API_URL}flow/lodrive-create-file`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: payload
    });
  },

  LodriveDownloadFile(token, fileID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/lodrive-generate-download-link`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        fileID
      }
    });
  },

  LodriveUpdateFolderTitle(token, directoryID, title) {
    return axios({
      method: "post",
      url: `${API_URL}flow/lodrive-update-directory-title`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        directoryID,
        title
      }
    });
  },

  LodriveRemoveFolder(token, directoryID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/lodrive-remove-directory`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        directoryID
      }
    });
  },

  LodriveRemoveFile(token, fileID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/lodrive-remove-file`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        fileID
      }
    });
  },

  LodriveGetSizeOfMyDrive(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/lodrive-get-size-of-my-drive`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      }
    });
  },

  LodriveGetRootDirectoryContents(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/lodrive-get-root-directory-contents`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      }
    });
  },

  LodriveGetDirectoryContent(token, directoryID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/lodrive-get-directory-contents`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        directoryID
      }
    });
  },

  LodriveMoveFileToDirectory(token, directoryID, fileID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/lodrive-move-file-to-directory`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        fileID,
        directoryID
      }
    });
  },

  LodriveMoveDirectoryToDirectory(token, topDirectoryID, directoryID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/lodrive-move-directory-to-directory`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        topDirectoryID,
        directoryID
      }
    });
  },

  LodriveDownloadDirectory(token, directoryID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/lodrive-download-directory-as-zip`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        directoryID
      }
    });
  },

  LodriveRenameFile(token, fileID, newFileName) {
    return axios({
      method: "post",
      url: `${API_URL}flow/lodrive-rename-file`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        fileID,
        newFileName
      }
    });
  },

  AutomationGetNodes(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/automation-get-nodes`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      }
    });
  },

  CreateFlowchart(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/flowcharts-create`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        title: "New Diagram",
        flowchart: {
          element: ""
        }
      }
    });
  },

  UpdateFlowchart(token, flowchartID, title, element) {
    return axios({
      method: "post",
      url: `${API_URL}flow/flowcharts-update`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        flowchartID,
        title,
        flowchart: {
          element
        }
      }
    });
  },

  GetFlowcharts(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/flowcharts-get`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      }
    });
  },

  RemoveFlowchart(token, flowchartID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/flowcharts-remove`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        flowchartID
      }
    });
  },

  CreateChecklist(token, title, step, projectID, description) {
    return axios({
      method: "post",
      url: `${API_URL}flow/checklist-create`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        title,
        description: description,
        isQueueRestricted: step,
        workspaceID: projectID
      }
    });
  },
  GetChecklistsByWorkspaceID(token, projectID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/checklist-get`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        workspaceID: projectID
      }
    });
  },

  UpdateChecklist(token, title, elements, description, checklistID, isQueueRestricted) {
    return axios({
      method: "post",
      url: `${API_URL}flow/checklist-update`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        checklistID,
        elements,
        title,
        description,
        isQueueRestricted
      }
    });
  },
  DeleteChecklist(token, checklistID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/checklist-remove`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        checklistID
      }
    });
  },
  GetUserNotifications(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/user-notifications-get`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      }
    });
  },
  SocialHiveGetChannelDetails(token, channelID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-get-channel`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        channelID
      }
    });
  },

  SendDMNotification(token, roomId, recipientId, senderName, messageContent, messageId, senderId, expoToken = null) {

    const notificationData = {
      sourceDevice: "WebApp",
      MainModule: "SocialHive",
      action: "openDM",
      roomId: roomId,
      roomTitle: senderName,
      userId: recipientId,
      userName: senderName,
      messageId: messageId,
      senderId: senderId,
      notificationData: "mobileApp",
    };
    return axios({
      method: "post",
      url: `${API_URL}flow/send-push-notification`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        title: senderName,
        token: expoToken,
        body: messageContent || "New message",
        data: notificationData
      }
    });
  },

  AutomationCreateWorkflow(token, title, workflowSchema) {
    return axios({
      method: "post",
      url: `${API_URL}flow/automation-create-workflow`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        title,
        workflowSchema
      }
    });
  },

  AutomationUpdateWorkflow(token, workflowID, updateData) {
    return axios({
      method: "post",
      url: `${API_URL}flow/automation-update-workflow`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        workflowID,
        updateData
      }
    });
  },

  AutomationGetWorkflowByID(token, workflowID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/automation-get-workflow-by-id`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        workflowID
      }
    });
  },

  AutomationGetWorkflowsByUser(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/automation-get-workflows-by-user-id`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      }
    });
  },

  AutomationDeleteWorkflow(token, workflowID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/automation-delete-workflow`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        workflowID
      }
    });
  },

};
